import { render, staticRenderFns } from "./RecruitmentStatisticsPage.vue?vue&type=template&id=7a3b9fb6&scoped=true"
import script from "./RecruitmentStatisticsPage.vue?vue&type=script&lang=js"
export * from "./RecruitmentStatisticsPage.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentStatisticsPage.vue?vue&type=style&index=0&id=7a3b9fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3b9fb6",
  null
  
)

export default component.exports